<template>
  <div>
    <module-card title="筛选">
      <el-form :model="searchForm" :inline="true" label-position="left">
        <el-form-item label="操作时间">
          <date-range-picker :value="actTime" @getChange="value => actTime = value"></date-range-picker>
        </el-form-item>
        <el-form-item label="活动编号">
          <el-input v-model="searchForm.activityCode" placeholder="请输入活动编号" :clearable="true"></el-input>
        </el-form-item>
        <el-form-item label="活动名称">
          <el-autocomplete
          v-model="searchForm.activityName"
          :fetch-suggestions="querySearch"
          placeholder="请输入活动名称"
          :trigger-on-focus="false"
          value-key="name"
          clearable
          style="width: 202px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="操作页面">
          <el-select clearable v-model="searchForm.operationPage" class="selectWidth">
            <el-option label="活动管理页" :value="1"></el-option>
            <el-option label="编辑活动页" :value="2"></el-option>
            <el-option label="商户管理页" :value="3"></el-option>
            <el-option label="额度包管理页" :value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="操作状态">
          <el-select clearable v-model="searchForm.operationStatus" class="selectWidth">
            <el-option label="成功" :value="1"></el-option>
            <el-option label="失败" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
        <el-button :loading="exportLoading" @click="exportList">导出</el-button>
      </el-form>
    </module-card>
    <module-card title="操作日志">
      <el-table class="table" border :data="list" v-loading="searchLoading">
        <el-table-column
          label="操作时间"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="操作模块"
          prop="menuName">
        </el-table-column>
        <el-table-column
          label="操作页面"
          prop="pageName">
        </el-table-column>
        <el-table-column
          label="活动编号"
          prop="activityId">
        </el-table-column>
        <el-table-column
          label="活动名称"
          prop="activityName">
        </el-table-column>
        <el-table-column
          label="操作账号"
          prop="operatorId">
        </el-table-column>
        <el-table-column
          label="操作人名称"
          prop="operatorName">
        </el-table-column>
        <el-table-column
          label="操作内容"
          prop="operationContent">
        </el-table-column>
        <el-table-column
          label="操作状态"
          prop="operationStatusMsg">
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="pageNo" :size="pageSize" @changePage="value => { this.pageNo = value; getList() }"></pagination>
    </module-card>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import dateRangePicker from '@/components/dateRangePicker'
import { downJumpConfirm } from '@/assets/js/utils'

export default {
  name: 'bankManage',
  components: {
    pagination,
    dateRangePicker
  },
  data () {
    return {
      actTime: [],
      searchForm: {
        operationTimeStart: '',
        operationTimeEnd: '',
        activityCode: '',
        activityName: '',
        operationPage: '',
        operationStatus: ''
      },
      searchLoading: false,
      exportLoading: false,
      pageNo: 1,
      pageSize: 10,
      list: []
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      this.getList()
    },
    getList () {
      this.searchLoading = true
      this.searchForm.operationTimeStart = this.actTime[0] || ''
      this.searchForm.operationTimeEnd = this.actTime[1] || ''
      const params = Object.assign({}, this.searchForm, {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
      for (const key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      this.$axios.post(this.$api.operationList, params).then(res => {
        if (res.respCode === '0') {
          this.list = res.data.list
          this.total = res.data.count
        }
        this.searchLoading = false
      })
    },
    search () {
      // this.pagination
      this.pageNo = 1
      this.getList()
    },
    exportList () {
      if (this.exportLoading) {
        return
      }
      this.exportLoading = true
      this.searchForm.operationTimeStart = this.actTime[0] || ''
      this.searchForm.operationTimeEnd = this.actTime[1] || ''
      const params = Object.assign({}, this.searchForm)
      for (const key in params) {
        if (params[key] === '') {
          delete params[key]
        }
      }
      this.$axios.post(this.$api.exportOperationList, params).then(res => {
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
        this.exportLoading = false
      })
    },
    querySearch (queryString, cb) {
      const result = []
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (queryString === '') {
          cb(result)
        } else {
          this.$axios.post(this.$api.activityFuzzySearch, {
            name: queryString
          }).then(res => {
            if (res.respCode === '0') {
              var result = res.data
              cb(result)
            } else {
              result = []
              cb(result)
            }
          })
        }
      }, 1000)
    }
  }
}
</script>
<style scoped>
.table{
  margin-top: 20px;
}
.form-flex-item {
  margin-right: 5px;
}
.icon {
  width: 14px;
  height: 14px;
  text-align: center;
  font-size: 12px;
  line-height: 12px;
  border-radius: 50%;
  display: inline-block;
  background: #409EFF;
  color: #fff;
  margin-left: 12px;
  cursor: pointer;
  user-select: none; /* Standard syntax */
}
.form-input {
  width: 610px;
}
.inner-input {
  width: 230px;
}
</style>
